import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable, Page } from '@shapeable/types';
import { breakpoints, theme, ColorTokens } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ViewRenderer } from '@shapeable/ui';

const cls = classNames('page-conversations-view-layout');

// -------- Types -------->

// -------- Props -------->

export type PageConversationsViewLayoutProps = Classable & HasChildren & { 
  entity?: Page;
};

export const PageConversationsViewLayoutDefaultProps: Omit<PageConversationsViewLayoutProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    display: flex;
    flex-direction: column;
  `,
});

const ViewStyles = breakpoints({
  base: css`
    height: 100%;
    .shp--slice-layout-conversations {
      padding-top: 12px;
    }
  `,
});


// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    View: styled(ViewRenderer)`${ViewStyles}`,
};

export const PageConversationsViewLayout: Shapeable.FC<PageConversationsViewLayoutProps> = (props) => {
  const { className, children, entity } = props;

  const { views = [] } = entity || {};

  const mainViews = views.filter(view => view?.slug === 'main');

  if (!mainViews.length) {
    return null;
  };
  
  return (
    <My.Container className={cls.name(className)}>
      {
        mainViews.map((view, i) => <My.View entity={view} key={view.id} />)
      }
    </My.Container>
  )
};

PageConversationsViewLayout.cls = cls;